import { sample } from 'lodash-es'
import type { SeenMedplumClient } from '#src/client.ts'
import { getCodingFromCodeableConcept } from '#src/codeableConcept.ts'
import { SIGNATURE_REQUEST_TYPE, TASK_TYPE } from '#src/codeSystems.ts'
import { invariant } from '#src/invariant.ts'
import { ExtendedOrganization } from '#src/models/organizations/ExtendedOrganization.ts'
import { TaskLabel } from '#src/models/taskLabel/taskLabel.ts'
import type { StandardTask } from '#src/models/tasks/index.ts'

export async function getTaskLabelForTask(
  medplum: SeenMedplumClient,
  task: StandardTask
): Promise<TaskLabel> {
  const { code, display } =
    getCodingFromCodeableConcept(task.code, TASK_TYPE) ??
    getCodingFromCodeableConcept(task.code, SIGNATURE_REQUEST_TYPE) ??
    {}
  invariant(display, 'Task type display not found')
  invariant(code, 'Task type code not found')
  const seenHealthOrg = await medplum.searchOneResourceClass(
    ExtendedOrganization,
    ExtendedOrganization.querySeenHealthOrg()
  )
  invariant(seenHealthOrg, 'Seen Health org not found')
  const taskLabelDraft = new TaskLabel({
    name: display,
    color:
      sample(TaskLabel.defaultColors)?.color ??
      TaskLabel.defaultColors[0].color,
    author: seenHealthOrg.reference,
    systemManagedId: code,
  })
  return medplum.createResourceClassIfNoneExist(
    taskLabelDraft,
    TaskLabel.bySystemManagedId(code)
  )
}
